// extracted by mini-css-extract-plugin
export default {"logo":"Layout_logo__6XrLK"};